import { handleActions, combineActions } from 'redux-actions';
import * as actions from '../actions/listingActions';

const toItem = item => {
  return {
    key: item,
    value: item,
    text: item,
  };
};

const defaultState = {
  current: {},
  listings: [],
  typeOptions: ['Property', 'Property w/o Realtor', 'Product'].map(toItem),
  count: 0,
  pages: 0,
  view: 'table',
  activePage: 1,
  query: {
    showcaseFirmId: '',
    description1: '',
    address: '',
    type: '',
  },
};

const reducer = handleActions(
  {
    [combineActions(actions.getListingsSuccess, actions.searchListingsSuccess)]: (
      state,
      { payload: { listings, count } }
    ) => {
      return { ...state, listings, count, pages: Math.ceil(count / 20) };
    },
    [combineActions(actions.paginate, actions.setActivePage)]: (state, { payload: { activePage } }) => {
      return { ...state, activePage };
    },
    [combineActions(actions.setCurrentListing, actions.getListingByIdSuccess, actions.updateListingSuccess)]: (
      state,
      { payload: { listing } }
    ) => {
      return { ...state, current: listing };
    },
    [actions.setQuery]: (state, { payload: { query } }) => {
      return { ...state, query };
    },
    [actions.setView]: (state, { payload: { view } }) => {
      return { ...state, view };
    },
  },
  defaultState
);

export default reducer;
